export function buildLookup<T>(
  items: T[],
  keyFn: ((item: T) => string) | keyof T,
): Map<string, T> {
  return items.reduce((lookup, item) => {
    if (typeof keyFn !== "function") {
      lookup.set(item[keyFn] as string, item);
    } else {
      const key = keyFn(item);
      lookup.set(key, item);
    }
    return lookup;
  }, new Map<string, T>());
}

export function pickUnique<T>(arr: T[], count: number): T[] {
  if (count > arr.length) {
    throw new Error("Requested more elements than available in array");
  }

  const copy = [...arr];

  for (let i = copy.length - 1; i > copy.length - count - 1; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }

  return copy.slice(copy.length - count);
}
